export default __webpack_public_path__ + "static/media/hkt.f8e02780.svg";